export interface TelegramMockProfile {
  id: string
  role: 'student' | 'teacher'
  telegramId: string
  name: string
  flowNo?: string
}

export const TELEGRAM_MOCK_MAP: Record<string, TelegramMockProfile> = {
  '470227422': {
    id: 'student-oleg-reytarov-470227422',
    role: 'student',
    telegramId: '470227422',
    name: 'Олег Рейтаров',
    flowNo: '171',
  },
  // Добавить себя как teacher:
  'TEACHER_ID': {
    id: 'teacher-oleg',
    role: 'teacher',
    telegramId: 'TEACHER_ID',
    name: 'Олег Рейтаров',
    flowNo: '172',
  },
  '123456789': {
    id: 'student-uuid-1',
    role: 'student',
    telegramId: '123456789',
    name: 'Ордабай Даулет',
    flowNo: '171',
  },
  '987654321': {
    id: 'teacher-uuid-1',
    role: 'teacher',
    telegramId: '987654321',
    name: 'Петрова Мария',
    flowNo: '172',
  },
}
